import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import * as Bixby from '$/core';
import HeadingTab from '$/components/global/headingTab';
import { Routes, Route } from 'react-router-dom';
import HeadBlock from '$/components/global/heading';
import GeneralSettings from './general';
import DataSiteHostSettings from './datasite-hosts';

interface ISettingsProps {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  settings?: Bixby.Models.Settings;
}

const AdminSettings: React.FC<ISettingsProps> = () => {
  const baseUrl = '/admin/settings';
  return (
    <React.Fragment>
      <HeadBlock title={'Settings'}>
        <HeadingTab title={'General'} link={baseUrl} />
        <HeadingTab title={'Data Site Hosts'} link={`${baseUrl}/datasite-hosts`} />
      </HeadBlock>
      <Routes>
        <Route path={'/'} element={<GeneralSettings />} />
        <Route path={'/datasite-hosts'} element={<DataSiteHostSettings />} />
      </Routes>
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.settingsState.isLoading,
    error: state.settingsState.error,
    settings: state.settingsState.settings,
  };
};

export default connect(mapStateToProps)(AdminSettings);
